import { createApp } from 'vue'
import App from './App.vue'
import Axios from 'axios'
import router from './router'
import { rule } from './directives/rule'

import './styles/tokens.css'
import './styles/sumi.css'

const axios = Axios.create({
    baseURL: 'https://ncdotnetapi-hdhdhaayfufqf4fy.westeurope-01.azurewebsites.net'
});

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.use(router);
app.directive('rule', rule);
// Mount once the first route's view has loaded, so the boot loader in index.html stays up until then.
router.isReady().then(() => app.mount('#app'));

// InkRipple (the Takeda-bishi opening at every click) is kept as a variant in utils/ripple.js but not shown on any page
// for now. To bring it back: import { installRipples } from './utils/ripple' and call installRipples() here.
